import { Alert, Box, keyframes } from "@mui/material";
import {
  getLocalStorageItem,
  isIdentical,
  saveStringify,
  setLocalStorageItem,
} from "data/functions";
import { isObjectEmpty } from "data/functions";
import React from "react";
import { v4 as uuidv4 } from "uuid";
export const AlertContext = React.createContext();

const appear = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

function AlertProvider({ children }) {
  const [alertArray, setAlertArray] = React.useState([]);
  const [isMobile, setIsMobile] = React.useState(true);

  const setAlert = React.useCallback((value, param, secs = 3) => {
    let uuid = uuidv4();
    if (param === "warn") param = "warning";
    let alert = {
      id: uuid,
      text: typeof value !== "string" ? saveStringify(value) : value,
      type: param ?? "info",
    };
    setAlertArray((e) => [...e, alert]);
    setLocalStorageItem("lastAlert", alert);
    setTimeout(() => {
      setAlertArray((e) => e.filter((v) => v?.id !== uuid));
    }, secs * 1000);
  }, []);

  const clear = React.useCallback(() => {
    setAlertArray([]);
  }, []);

  const contextValue = React.useMemo(
    () => ({
      alert,
      clear,
      setAlert,
    }),
    // eslint-disable-next-line
    [alert, setAlert]
  );

  React.useEffect(() => {
    let mobileParam = getLocalStorageItem("data_deviceWidth");
    if (
      !isObjectEmpty(mobileParam) &&
      !isIdentical(mobileParam?.isMobile, isMobile)
    ) {
      setIsMobile(mobileParam?.isMobile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getLocalStorageItem("data_deviceWidth")]);

  return (
    <AlertContext.Provider value={contextValue}>
      <Box
        sx={{
          background: "transparent",
          display: "flex",
          flexDirection: "column-reverse",
          justifyContent: "center",
          position: "fixed",
          zIndex: 2000,

          width: "100%",
          // left: isMobile ? "0" : "256px",
        }}
      >
        {!isObjectEmpty(alertArray) &&
          (alertArray ? alertArray : [])
            .reverse()
            .slice(0, 3)
            .map((el, ind) => (
              <Alert
                icon={false}
                key={ind}
                onClose={() => {
                  setAlertArray((e) => e.filter((v) => v?.id !== el?.id));
                }}
                severity={el?.type}
                sx={{
                  ".MuiAlert-action": {
                    button: {
                      padding: "1px",
                      svg: {
                        height: "0.8em",
                        width: "0.8em",
                      },
                    },
                    marginLeft: "0",
                    marginRight: "0",
                    padding: "0px 6px",
                  },
                  ".MuiAlert-message": {
                    marginLeft: "auto",
                    marginRight: "auto",
                    padding: "2px",
                    textWrap: "balance",
                  },
                  alignItems: "center",
                  // margin: "2px",
                  animation: `${appear} .4s ease-in-out`,
                  // left: isMobile ? "0" : "256px",
                  justifyContent: "center",
                  lineHeight: "1",
                  marginBottom: "2px",
                  padding: "0px",
                  position: "sticky",
                  textAlign: "center",
                  top: "0",
                  whiteSpace: "pre-line",
                  // left: "0",
                  width: "100%",
                  zIndex: 2000,
                }}
                variant="filled"
              >
                {el?.text}
              </Alert>
            ))}
      </Box>

      {children}
    </AlertContext.Provider>
  );
}
export const GetAlertData = () => {
  const context = React.useContext(AlertContext);
  return context;
};

export { AlertProvider };
